import React from 'react'

const WhySection = ({ data }) => {
  const whyEMT = data.whyEMT;

  return (
    <section className="max-w-(--max-page-width) mx-auto px-(--container-padding) my-10 md:my-16 lg:my-24">
      <div className="max-w-6xl mx-auto text-center">

        <span className="bg-[#FFA2011A]/90 text-[#FFA201] text-[13px] font-normal px-3 py-2 capitalize">
          {whyEMT.tag}
        </span>

        <h2 className="text-[20px] md:text-[25px] lg:text-[30px] xl:text-[42px] w-full md:max-w-3xl lg:max-w-4xl mx-auto font-bold mt-4 leading-tight">
          {whyEMT.title}
        </h2>

        <p className="text-black text-lg mt-4 max-w-3xl mx-auto">
          {whyEMT.description}
        </p>
            <div className="flex justify-center gap-6 mt-12 flex-wrap">
              {whyEMT.stats.map((item, index) => (
                <div
                  key={index}
                  className="bg-[#1f6f9b] text-white p-8 border-t-4 border-orange-400 w-[360px]"
                >
                  <h3 className="text-[20px] md:text-[25px] lg:text-[30px] xl:text-[42px] font-dmSerif font-semibold text-center">
                  {item.value}
                </h3>
                <p className="text-lg mt-4 leading-relaxed text-gray-100 text-center">
                  {item.text}
                </p>
                </div>
              ))}
            </div>
      </div>
    </section>
  )
}

export default WhySection